export default __webpack_public_path__ + "static/media/service5.d2662505.jpeg";